module.exports = __webpack_public_path__ + "img/suporte.0cfe4d4b.png";